export default __webpack_public_path__ + "static/media/parts2.383b7fa7.webp";